module.exports = __webpack_public_path__ + "static/media/22n.a471082e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/22n.svg
// module id = 165
// module chunks = 0